import { Hotel } from '@/components/pages/event/layout/components/hotel-booking/components/hotel-cards';
import hotelBookingMap from '@/components/pages/event/layout/components/hotel-booking/utils/hotel-booking-map';

const getHotels = (slug: string): Hotel[] => {
    return hotelBookingMap[slug] ?? [];
};

export default getHotels;
